import { AsyncPipe } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  HostListener,
  inject,
  input,
} from '@angular/core';

import {
  FU_SORT,
  FU_SORT_DOWN,
  FU_SORT_UP,
  IconModule,
  IconSize,
  registerIcons,
} from '@hglobal/fin-ui';

import { SortDirective } from './sort.directive';

/**
 * Uses next icons: fu-sort-up, fu-sort-down, fu-sort
 */
@Component({
  selector: 'iw-sort',
  standalone: true,
  imports: [AsyncPipe, IconModule],
  templateUrl: './sort.component.html',
  styleUrl: './sort.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SortComponent {
  readonly #container = inject(SortDirective);

  colName = input<string>();
  iconSize = input<IconSize>('16');
  withDefaultIcon = input<boolean>();

  sort$ = this.#container.sort$;

  constructor() {
    registerIcons([FU_SORT_UP, FU_SORT_DOWN, FU_SORT]);
  }

  @HostListener('click') onClick() {
    this.#container.handleSort(this.colName());
  }
}
